import { Link, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
// import { useState } from 'react'

import { ReactComponent as Add } from '../assets/icons/add.svg'
import { ReactComponent as Edit } from '../assets/icons/edit.svg'
import { ReactComponent as Close } from '../assets/icons/close.svg'

import ClassSessionTab from '../components/ClassSessionTab.jsx'
import { ClassDataNull, ClassSessionNull, ClassStudentNull } from '../components/ClassNull.jsx'
import ClassDataTab from '../components/ClassDataTab.jsx'
import ClassStudentTab from '../components/ClassStudentTab.jsx'
import { DeleteModal } from '../components/Modal.jsx'
import SessionAddCard from '../components/SessionAddCard.jsx'
import { dayEnumList } from '../assets/data.js'
import { getDocuments } from '../apis/document.ts'
import { getCoursesStudent } from '../apis/course.ts'
import { getSessions } from '../apis/session.ts'
// import { getSessions } from '../apis/session.ts'

export default function ClassDetailView() {
  const location = useLocation()
  // console.log(location.state)
  const [sessionList, setSessionList] = useState()
  const [studentList, setStudentList] = useState()
  const [documentList, setDocumentList] = useState()

  const [isLessonAdd, setIsLessonAdd] = useState(false)
  const [isLessonEdit, setIsLessonEdit] = useState(false)
  const handleEditState = () => {
    setIsLessonEdit((prev) => !prev)
  }

  const [selectedTab, setSelectedTab] = useState(0)

  const tabList = [
    {
      name: '수업 차시',
      key: 'lesson',
      component: () => (
        <ClassSessionTab
          semesterId={location.state.data.semester.id}
          courseId={location.state.data.id}
          editState={isLessonEdit}
          addState={isLessonAdd}
          onStateChange={handleEditState}
          // subjectId={location.state.data.subject.id}
          classData={location.state.data}
        />
      ),
      null: () => <ClassSessionNull onStateChange={() => setIsLessonAdd((prev) => !prev)} />,
      data: sessionList,
    },
    {
      name: '수강 학생 관리',
      key: 'student',
      data: studentList,
      component: () => (
        <ClassStudentTab
          courseId={location.state.data.id}
          semesterId={location.state.data.semester.id}
        />
      ),
      null: () => (
        <ClassStudentNull
          courseId={location.state.data.id}
          semesterId={location.state.data.semester.id}
          studentList={studentList}
        />
      ),
    },
    {
      name: '과목 자료실',
      key: 'data',
      component: () => <ClassDataTab subjectId={location.state.data.subject.id} />,
      null: () => (
        <ClassDataNull
          subjectId={location.state.data.subject.id}
          getApi={() => getDocumentsApi()}
        />
      ),
      data: documentList,
    },
  ]

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const key = queryParams.get('key')

    if (key) {
      setSelectedTab(tabList.findIndex((item) => item.key === key))
    } else {
      setSelectedTab(0)
    }
    // eslint-disable-next-line
  }, [location.search])

  const [isModalOpen, setIsModalOpen] = useState(false)
  const openModal = () => {
    setIsModalOpen(true)
  }
  const closeModal = () => {
    setIsModalOpen(false)
  }

  const courseTimes = () => {
    const result = location.state.data.courseTimeTable.reduce((acc, curr) => {
      const { dayOfWeek } = curr
      if (acc[dayOfWeek]) acc[dayOfWeek].push(curr)
      else acc[dayOfWeek] = [curr]
      return acc
    }, [])
    const times = []
    Object.entries(result).forEach(([key, value]) => {
      const periods = value.map((item) => item.coursePeriod).join(',')
      times.push(`${dayEnumList[key]} ${periods}교시`)
    })
    return times
  }

  useEffect(() => {
    getSessionsApi()
    getDocumentsApi()
    getCoursesStudentApi()
    // eslint-disable-next-line
  }, [])
  /*************** 차시 조회 API **************/

  const getSessionsApi = async () => {
    const getSessionsResponse = await getSessions({
      courseId: location.state.data.id,
    })

    if (getSessionsResponse.error) {
      console.log(getSessionsResponse)
      return
    } else {
      // console.log(getSessionsResponse.data)
      setSessionList(getSessionsResponse.data.flatMap((item) => item.sessions))
    }
  }

  /*************** 수업 학생 조회 API **************/

  const getCoursesStudentApi = async () => {
    const getCoursesStudentResponse = await getCoursesStudent({
      courseId: location.state.data.id,
      // sortBy: getCategoryType(sortedBy),
      // name: search,
    })

    if (getCoursesStudentResponse.error) {
      console.log(getCoursesStudentResponse)
      return
    } else {
      setStudentList(getCoursesStudentResponse.data)
    }
  }

  /*************** 자료목록 조회 API **************/

  const getDocumentsApi = async () => {
    const getDocumentsResponse = await getDocuments({
      subjectId: location.state.data.subject.id,
      // name: search,
      // sortBy: getCategoryType(sortedBy),
    })

    if (getDocumentsResponse.error) {
      console.log(getDocumentsResponse.error)
      return
    } else {
      // console.log(getDocumentsResponse.data)
      setDocumentList(getDocumentsResponse.data)
    }
  }

  return (
    <div className='h-full'>
      <div className={`${selectedTab === 0 ? 'mb-40' : 'mb-24'} flex flex-col items-start gap-12`}>
        {/* class title */}
        <div
          className='relative flex w-full items-start justify-between rounded-16 bg-background-alternative px-24 py-20'
          style={{ backgroundColor: location.state.data.image.backgroundColor }}
        >
          <div className='absolute right-[100px] top-0 h-full w-[205px]'>
            <img className='mix-blend-overlay' src={location.state.data.image.imageUrl} alt='' />
          </div>
          <div className='flex flex-col items-start gap-16'>
            <div className='flex flex-col items-start gap-4'>
              <p className='text-body2-medium text-label-sub'>
                {location.state.data.teacher.name} 선생님
              </p>
              <div className='flex items-center gap-8'>
                <p
                  className='text-title2-bold text-label-strong'
                  // style={{
                  //   color: location.state.data.image.textColor,
                  // }}
                >
                  {location.state.data.subject.name}
                </p>
                <p className='text-body1-medium text-label-default'>
                  {location.state.updatedData
                    ? location.state.updatedData.className
                    : location.state.data.className}
                </p>
              </div>
            </div>
            <div className='flex items-center gap-8'>
              <p className='text-body3-medium text-label-sub'>
                {location.state.data.semester.name}
              </p>
              <div className='h-12 w-[1px] bg-label-sub' />
              <p className='text-body3-medium text-label-sub'>{courseTimes().join('/')}</p>
            </div>
          </div>
          <div className='flex gap-28'>
            <Link
              to={'/class/update'}
              state={location.state}
              className='flex cursor-pointer items-center gap-4'
            >
              <Edit />
              <p className='text-body2-medium text-label-sub'>수업 수정</p>
            </Link>
          </div>
        </div>
        {/* tab */}
        <div className='flex w-full items-center justify-between'>
          <div className='flex items-start gap-20'>
            {tabList.map((tabItem, tabIndex) => (
              <Link
                key={tabIndex}
                onClick={() => {
                  setSelectedTab(tabIndex)
                  setIsLessonAdd(false)
                  setIsLessonEdit(false)
                }}
                to={`/class/detail?key=${tabItem.key}`}
                state={location.state}
                className={`flex h-40 min-w-[100px] shrink-0 items-center justify-center px-4 ${selectedTab === tabIndex ? 'border-b-solid border-b-[3px] border-primary-normal text-body1-semibold text-label-default' : 'text-body1-medium text-label-info'} `}
              >
                {tabItem.name}
              </Link>
            ))}
          </div>
          {selectedTab === 0 &&
            (isLessonEdit ? (
              <button
                onClick={() => {
                  openModal()
                }}
                className='button_outlined_assistive_sm gap-4 fill-label-sub'
              >
                <Close />
                <p>정보 수정 취소</p>
              </button>
            ) : isLessonAdd ? (
              <button
                onClick={() => {
                  openModal()
                }}
                className='button_outlined_assistive_sm gap-4 fill-label-sub'
              >
                <Close />
                <p>차시 추가 취소</p>
              </button>
            ) : (
              <button
                onClick={() => setIsLessonAdd((prev) => !prev)}
                className='button_outlined_assistive_sm gap-4 fill-label-sub'
              >
                <Add className='h-16 w-16' />
                <p>차시 추가</p>
              </button>
            ))}
        </div>
      </div>
      <div className={`relative ${isLessonAdd ? 'h-[calc(100%-355px)]' : 'h-[calc(100%-225px)]'} `}>
        {selectedTab === 0 && (
          <img
            src={require('../assets/images/gradient-white.png')}
            alt=''
            className={`pointer-events-none absolute z-[2] w-full ${isLessonAdd ? 'top-[162px]' : 'top-32'}`}
          />
        )}
        {selectedTab === 0 && isLessonAdd && (
          <SessionAddCard
            semesterId={location.state.data.semester.id}
            courseId={location.state.data.id}
            onStateChange={() => setIsLessonAdd((prev) => !prev)}
          />
        )}
        {tabList[selectedTab].data?.length === 0
          ? tabList[selectedTab].null()
          : tabList[selectedTab].component()}
        {selectedTab === 0 && (
          <img
            src={require('../assets/images/gradient-white.png')}
            alt=''
            className={`${isLessonAdd ? '-bottom-[130px]' : 'bottom-0'} pointer-events-none absolute z-[2] w-full rotate-180`}
          />
        )}
      </div>
      {isModalOpen && isLessonAdd && (
        <DeleteModal
          close={closeModal}
          onStateChange={() => setIsLessonAdd((prev) => !prev)}
          content={'lessonAdd'}
        />
      )}
      {isModalOpen && isLessonEdit && (
        <DeleteModal
          close={closeModal}
          onStateChange={() => setIsLessonEdit((prev) => !prev)}
          content={'lessonEdit'}
        />
      )}
    </div>
  )
}
